var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66659 4.00016V2.00016C4.66659 1.82335 4.73682 1.65378 4.86185 1.52876C4.98687 1.40373 5.15644 1.3335 5.33325 1.3335H10.6666C10.8434 1.3335 11.013 1.40373 11.138 1.52876C11.263 1.65378 11.3333 1.82335 11.3333 2.00016V4.00016H14.6666V5.3335H13.3333V14.0002C13.3333 14.177 13.263 14.3465 13.138 14.4716C13.013 14.5966 12.8434 14.6668 12.6666 14.6668H3.33325C3.15644 14.6668 2.98687 14.5966 2.86185 14.4716C2.73682 14.3465 2.66659 14.177 2.66659 14.0002V5.3335H1.33325V4.00016H4.66659ZM8.94258 9.3335L10.1213 8.15483L9.17859 7.21216L7.99992 8.39083L6.82125 7.21216L5.87859 8.15483L7.05725 9.3335L5.87859 10.5122L6.82125 11.4548L7.99992 10.2762L9.17859 11.4548L10.1213 10.5122L8.94258 9.3335ZM5.99992 2.66683V4.00016H9.99992V2.66683H5.99992Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWhite);
export default __webpack_public_path__ + "static/media/delete-white.467f4ef6935922b3e16ce88958dc6c2b.svg";
export { ForwardRef as ReactComponent };